import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { CallToActionButtonData } from './call-to-action-button.component.converter'
import { CmsBaseComponent } from '../cms-base-component/cms-base.component'

@Component({
  selector: 'mb-call-to-action-button',
  templateUrl: './call-to-action-button.component.html',
  styleUrls: ['./call-to-action-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallToActionButtonComponent extends CmsBaseComponent<CallToActionButtonData> {
  @Input() mobile: boolean | undefined
  @Input() number: number | undefined
}
